import React, { useEffect, useState } from "react";
import {
  HeaderModal,
  Loading,
  Button,
  FormInfo,
  Toast,
} from "../../../../components";
import classNames from "classnames/bind";
import styles from "./BillTable.module.css";
import { useForm } from "antd/es/form/Form";
import axiosClient from "../../../../services/axiosClient";
import { manageNotification } from "../../../../services/api/manageNotification";
import { Col, Row, Typography } from "antd";

const cx = classNames.bind(styles);
const Modal = ({ onClose, handleRefresh, id }) => {
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const [isTelegram, setIsTelegram] = useState(false);
  const [listUser, setListUser] = useState([]);
  const handleChangeChanel = (val) => {
    if (val === 'TELEGRAM') {
      setIsTelegram(!isTelegram)
    } else {
      setIsTelegram(false)
    }
  }
  const handleChangeUserName = (val) => {
    const detail = listUser?.find(item => item?.USERNAME === val);
    form.setFieldValue("name", detail?.NAME);
    form.setFieldValue("company_name", detail?.COMPANY_NAME);
  }

  useEffect(() => {
    const getListUser = async () => {
      try {
        const res = await axiosClient.get("/userManagement/get-list-user/");
        if (res?.data) {
          const users = res?.data?.map(item => {
            return {
              label: item?.USERNAME || "",
              value: item?.USERNAME || "",
              ...item
            }
          });
          setListUser(users)
        }

      } catch (error) {
        // console.log(error);
      }
    }
    getListUser()
  }, [])
  const listInfo = [
    {
      label: "Tên tài khoản",
      type: 'autocomplete',
      name: 'user_name',
      span: 8,
      showSearch: true,
      // onSearch: handleSearch
      onChange: handleChangeUserName,
      options: listUser,
    },
    {
      label: "Tên hiển thị",
      type: "input",
      name: "name",
      span: 8,
      disabled: true,
    },
    {
      label: "Tên đơn vị",
      type: "input",
      name: "company_name",
      span: 8,
      disabled: true,
    },
    {
      label: "Kênh thông báo",
      type: "select",
      name: "chanel",
      onChange: handleChangeChanel,
      span: 8,
      options: [
        {
          value: 'TELEGRAM',
          label: 'Telegram',
        },
        {
          value: 'APP',
          label: 'App',
        }
      ]
    },
    {
      label: "Id telegram *",
      type: "input",
      name: "chat_id",
      span: 8,
      hide: !isTelegram,
      placeholder: '@exemple',
      rules: [{ required: true, message: 'Please input your username!' }]
    },
  ]

  const handleConnect = async () => {
    try {
      const formInfo = form?.getFieldsValue();
      // // console.log(form?.getFieldError('chat_id'));

      const chanelInfo = {
        method: formInfo?.chanel,
        username: formInfo?.user_name
      }
      // crud bản ghi kênh thông báo
      if (formInfo?.chanel === 'TELEGRAM') {
        const data = {
          chat_id: formInfo?.chat_id
        }
        await manageNotification.postUpdateConnectTelegramNotification(data);
      }
      if (id) {
        await manageNotification.putChangeChanel(id, chanelInfo);
      } else {
        await manageNotification.postAddNotificationChannel(chanelInfo);
      }
      Toast.open("Liên kết kênh thông báo thành công", "success")
      onClose();
      handleRefresh();
    } catch (error) {
      Toast.open("Liên kết kênh thông báo không thành công", "danger")
    }
  }

  useEffect(() => {
    if (id) {
      const getInfoNotifiChanel = async () => {
        try {
          const param = {
            notification_channel_code: id
          }
          const res = await manageNotification.getListNotificationChanel(param);
          if (res?.data) {
            res?.data?.forEach((item, index) => {
              form?.setFieldsValue({
                user_name: item?.USERNAME,
                name: item?.SUBJECT_NAME,
                company_name: item?.COMPANY_NAME || "",
                chanel: item?.METHOD || "",
                chat_id: item?.DETAIL ? item?.DETAIL?.split("'")[3] : ""
              })
              handleChangeChanel(item?.METHOD)
            });
          }
        } catch (error) {
          // console.log(error);
        }
      }
      getInfoNotifiChanel()
    }
  }, [id])
  return (
    <div className={cx("modal-info")}>
      <div className={cx("container")}>
        {!loading ? (
          <>
            <div style={{ padding: "0 12px" }}>
              <HeaderModal title={"Thêm kênh thông báo"} onClose={onClose} />
            </div>
            <div className={cx("data-info")}>
              <FormInfo listInfo={listInfo} form={form} />
            </div>
            <div className={cx("data-info")}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text italic>* Hướng dẫn lấy Id telegram </Typography.Text>
                </Col>
                <Col span={24}>
                  <Typography.Text italic> - Bước 1: Truy cập telegram
                    <Typography.Link href={`${process.env.REACT_APP_TELE_BOT_URL}`} target="_blank"> chat bot</Typography.Link>
                    {" "} hoặc truy cập app telegram và tìm kiếm "@vnscamerauatbot"
                  </Typography.Text>
                </Col>
                <Col span={24}>
                  <Typography.Text italic> - Bước 2: Gửi cho chat bot lệnh "/start"</Typography.Text>

                </Col>
                <Col span={24}>
                  <Typography.Text italic> - Bước 3: Chat bot trả về ID cho bạn có dạng như sau "6023959842"</Typography.Text>

                </Col>
                <Col span={24}>
                  <Typography.Text italic> - Bước 4: Lấy ID đó và điền vào ô "Id telegram" ở biểu mẫu trên</Typography.Text>
                </Col>

              </Row>
            </div>
          </>
        ) : (
          <div className={cx("loading")}>
            <Loading />
          </div>
        )}
        <div className={cx("actions")}>
          <Button
            onClick={onClose}
            className={cx("btn-setting", "btn-cancel")}
            title={"Hủy bỏ"}
          />
          <Button
            onClick={handleConnect}
            className={cx("btn-setting")}
            title={"Liên kết"}
          />

        </div>
      </div>
    </div>
  );
};

export default Modal;
